import Header from '../header/headerScripts';
import Cart from '../header/headerCart';
import WishlistHeader from '../header/headerWishlist';
import FixedContent from '../utils/FixedContent';
import lazyLoad from '../utils/lazyLoad';
import contentFade from '../utils/ContentFadeIn';
import smoothScroll from '../utils/smoothScroll';
import mapScripts from '../utils/map';
import popup from '../utils/popup';
import accordion from '../utils/accordion';
import ProductSlider from '../utils/sliders-flickity';
import { CollectionsSlider } from '../utils/sliders-flickity';
import { landingSlider } from '../utils/sliders';
import initVideoIframe from '../utils/videoIframe';
import { archiveProductCols } from '../utils/equalCols.js';
import { archiveCols } from '../utils/equalCols.js';
//import SidebarScroll from '../utils/iScrollScripts.js';
//import { SidebarScrollMobile } from '../utils/iScrollScripts.js';
//import { SideNavScroll } from '../utils/iScrollScripts.js';
import { countWidth } from '../utils/iScrollScripts.js';
import scrollBanner from '../utils/landingBanner.js';
import cfFunc from '../utils/cfFunc.js';
import ajaxAddToCart from '../woocommerce/productAjax';
import { ajaxRemoveFromCart } from '../woocommerce/productAjax';
import Wishlist from '../woocommerce/wishlist-script';
import { onUpdateCheckout, removeTimesFromShipping, wrapCheckboxLabelText, toggleInvoiceFields } from '../woocommerce/checkoutAdditional';
import singleProductSidebar from '../woocommerce/singleProductSidebar';
import archiveNav from '../archive/stickyNavigation';
import showNewsletter from '../archive/archiveNewsletter';
import collectionsAjax from '../archive/collectionsAjax';
import moveBannerDOM from '../utils/bannerSection';
import showProductPopup from '../woocommerce/productPopup';

// GLOBAL APP CONTROLLER
class Controller {
    init() {
        document.querySelector('html').classList.remove('no-js');
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            document.querySelector('body').classList.add('safari-browser');
        }

        showProductPopup();
        lazyLoad();
        landingSlider.init();
        moveBannerDOM();
        Header.init();
        Cart.init();
        FixedContent.init();
        WishlistHeader.init();
        contentFade.init();
        smoothScroll.init();
        mapScripts.init();
        popup.init();
        accordion.init();
        ProductSlider.init();
        CollectionsSlider.init();
        Wishlist.init();
        //SidebarScroll.init();
        //ajaxAddToCart();
        //ajaxRemoveFromCart();
        scrollBanner();
        showNewsletter();
        collectionsAjax.init();
        cfFunc();
        removeTimesFromShipping();
        onUpdateCheckout();
        countWidth();
        //SidebarScrollMobile.init();
        //SideNavScroll.init();
        initVideoIframe();
        toggleInvoiceFields();
    }
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        archiveProductCols.init();
        Cart.loaded();
        WishlistHeader.loaded();
        archiveNav.init();
        wrapCheckboxLabelText();
        archiveCols();
    }
    resized() {
        if(document.querySelector('body').classList.contains('lock-scroll')){
            document.querySelector('body').classList.remove('lock-scroll')
        }
        countWidth();
        Header.closeNav();
        archiveNav.checkScroll();
    }
    scrolled() {
        FixedContent.checkScroll();
        singleProductSidebar();
    }
};

export default new Controller();
